import styled from "styled-components";

export const SelectElement = styled.select`
  padding: 10px 13px;

  font-size: 14px;
  font-weight: 500;

  color: #5e6278;
  border: 1px solid #e1e3ea;
  border-radius: 4px;
`;
